// extracted by mini-css-extract-plugin
export var alternate = "_1h-j";
export var black = "_1h-6";
export var blue = "_1h-f";
export var blueLight = "_1h-e";
export var brand = "_1h-8";
export var darkMode = "_1h-b";
export var error = "_1h-a";
export var gray = "_1h-5";
export var grayBlue = "_1h-d";
export var iconWrapper = "_1h-3";
export var inactive = "_1h-7";
export var indigo = "_1h-g";
export var orange = "_1h-i";
export var pink = "_1h-h";
export var primary = "_1h-0";
export var purple = "_1h-9";
export var success = "_1h-4";
export var warning = "_1h-c";
export var white = "_1h-1";
export var whiteSuccess = "_1h-2";